import * as React from 'react';
import _ from 'lodash';
import {
	TertiaryButton,
	Paragraph,
	Card,
	Svg,
	TextLink,
} from '@mlc/web-ui-toolkit';
import { exclamationTriangle } from '@mlc/symbols';
import * as palette from '@mlc/mlc-palette';
import searchTestIds from '../SearchResults.elements';
import * as Styled from './styled';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

export interface DownloadCsvProps {
	filterBy?: 'plan' | 'client' | 'group';
	label: string;
	icon: IconDefinition;
	fileName: string;
	filterDataInCsvFormat: Function;
	fetchDataToDownload: Function;
	csvHeader: string;
}

const DownloadCsv: React.FunctionComponent<DownloadCsvProps> = ({
	filterBy,
	icon,
	label,
	fileName,
	filterDataInCsvFormat,
	fetchDataToDownload,
	csvHeader,
}: DownloadCsvProps) => {
	const [loading, setLoading] = React.useState(false);
	const [error, setError] = React.useState(false);
	const handleOnClick = async () => {
		setLoading(true);
		setError(false);
		try {
			const data = await fetchDataToDownload();
			const dataForCsv = filterDataInCsvFormat(data, filterBy);

			const formattedData = _.join(dataForCsv, '\r\n');
			let csvContent = `${csvHeader}${formattedData}`;
			var blob = new Blob([csvContent]);
			//@ts-ignore
			if (window.navigator.msSaveOrOpenBlob)
				window.navigator.msSaveBlob(blob, `${fileName}.csv`);
			else {
				var a = window.document.createElement('a');
				// @ts-ignore
				a.href = window.URL.createObjectURL(blob, { type: 'text/plain' });
				a.download = `${fileName}.csv`;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}
			setLoading(false);
		} catch (Error) {
			setError(true);
			setLoading(false);
		}
	};
	if (error) {
		return (
			<Card display="flex" flexDirection="row" alignItems="center" padding={2}>
				<Svg symbol={exclamationTriangle} color={palette.mlcRed} />
				<Paragraph
					margin={0}
					padding={0}
					paddingLeft={1}
					paddingRight={1}
					color={palette.mlcRed}
				>
					Download failed.
				</Paragraph>
				<TextLink el="button" paddingLeft={0} onClick={handleOnClick}>
					Please try again
				</TextLink>
			</Card>
		);
	}

	return (
		<TertiaryButton
			data-id={searchTestIds.downloadDataLink}
			onClick={handleOnClick}
			isLoading={loading}
		>
			{!loading ? <Styled.DownloadIcon icon={icon} size="sm" /> : null}

			{loading ? 'Downloading...' : label}
		</TertiaryButton>
	);
};

export default DownloadCsv;
